var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContinueArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7489 5.75054C12.0837 5.4157 12.0837 4.87192 11.7489 4.53708L7.46292 0.25113C7.12808 -0.08371 6.5843 -0.08371 6.24946 0.25113C5.91462 0.58597 5.91462 1.12975 6.24946 1.46459L9.07551 4.28796H0.857191C0.383057 4.28796 0 4.67102 0 5.14515C0 5.61929 0.383057 6.00234 0.857191 6.00234H9.07283L6.25213 8.82571C5.91729 9.16055 5.91729 9.70434 6.25213 10.0392C6.58697 10.374 7.13076 10.374 7.4656 10.0392L11.7515 5.75322L11.7489 5.75054Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContinueArrow);
export default __webpack_public_path__ + "static/media/continue-arrow.62c331f79c29e02a7f15906e1d36d479.svg";
export { ForwardRef as ReactComponent };